import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { average, countUnique, override, sum } from '@utils/summaries';
import { basicSort } from '@utils/sort';
import { useMemo } from 'react';
import { styleDateRange } from '@utils/styles';

interface WarrantyRateByLocationProps {
    dateRange: { startDate: string; endDate: string };
}

export const WarrantyRateByLocation = ({ dateRange }: WarrantyRateByLocationProps) => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.LOCATION_WARRANTY_RATE_BY_LOCATION,
        params: { ...dateRange },
    });

    const calculateWarrantyPct = () => {
        const { totalCuts, totalSuccessful } = data.reduce(
            (acc, curr) => {
                acc.totalCuts += curr.totalCuts;
                acc.totalSuccessful += curr.successfulCuts;
                return acc;
            },
            { totalCuts: 0, totalSuccessful: 0 }
        );

        const numWarranty = totalCuts - totalSuccessful;

        return ((numWarranty / totalCuts) * 100).toFixed(2);
    };

    const warrantySummary = useMemo(calculateWarrantyPct, [data]);

    return (
        <BaseReport
            title={'Warranty Rate by Location'}
            description={
                'This table shows you the warranty rate for each of your locations allowing you to compare them to the global average, for the entire date range selected above.'
            }
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Company Name', 'Reseller Name', 'Location Name', 'Successful Cuts', 'Warranty %', 'Global Avg'],
                data: data.map((item) => [
                    item.companyName,
                    item.resellerName,
                    item.locationName,
                    item.successfulCuts,
                    item.warrantyPct,
                    item.globalAvg,
                ]),
                summaries: [countUnique, countUnique, countUnique, sum, override(warrantySummary), average],
                sort: [basicSort, basicSort, basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
